<template>
  <div class="asc-grid-drill-down-cell">
    <span class="asc-value">{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: 'AscGridDrillDownCell',

  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
}
</script>

<style lang="scss">
.asc-grid-drill-down-cell {
  display: flex;
  justify-items: center;

  .asc-value {
    color: $accent-700;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
